<template>
    <div>
        <el-button type="primary" size="mini" plain @click="getData">
            <span class="el-icon-edit-outline">编辑动态</span>
        </el-button>
        <el-dialog
            title="楼盘动态"
            :visible.sync="showdialog"
            width="1000px"
            v-dialogDrag
            append-to-body>
            <div class="base-warp">
                <el-tabs type="border-card" v-model="active_step">
                    <el-tab-pane label="待入市" name="0">
                        <div class="tab-box">
                            <el-form label-width="80px" :inline="false" size="mini">
                                <el-form-item label="日期">
                                    <el-input class="date-input" type="date" v-model="step1.time"></el-input>
                                </el-form-item>
                                <el-form-item label="内容">
                                    <el-input class="textarea" type="textarea" v-model="step1.content"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="即将取证" name="1">
                        <div class="tab-box">
                            <el-form label-width="80px" :inline="false" size="mini">
                                <el-form-item label="日期">
                                    <el-input class="date-input" type="date" v-model="step2.time"></el-input>
                                </el-form-item>
                                <el-form-item label="内容">
                                    <el-input class="textarea" type="textarea" v-model="step2.content"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="正在认筹" name="2">
                        <div class="tab-box">
                            <el-form label-width="80px" :inline="false" size="mini">
                                <el-form-item label="日期">
                                    <el-input class="date-input" type="date" v-model="step3.time"></el-input>
                                </el-form-item>
                                <el-form-item label="内容">
                                    <el-input class="textarea" type="textarea" v-model="step3.content"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="摇号开盘" name="3">
                        <div class="tab-box">
                            <el-form label-width="80px" :inline="false" size="mini">
                                <el-form-item label="日期">
                                    <el-input class="date-input" type="date" v-model="step4.time"></el-input>
                                </el-form-item>
                                <el-form-item label="内容">
                                    <el-input class="textarea" type="textarea" v-model="step4.content"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="持续销售" name="4">
                        <div class="tab-box">
                            <el-form label-width="80px" :inline="false" size="mini">
                                <el-form-item label="日期">
                                    <el-input class="date-input" type="date" v-model="step5.time"></el-input>
                                </el-form-item>
                                <el-form-item label="内容">
                                    <el-input class="textarea" type="textarea" v-model="step5.content"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <div class="sub-div">
                        <el-button type="primary" size="default" @click="save">保存</el-button>
                        <el-button type="default" size="default" @click="showdialog = false">取消</el-button>
                    </div>
                </el-tabs>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'ProjectDynamic',
    data() {
        return {
            showdialog: false,
            active_step: '0',
            step1: {
                time: '',
                content: '',
            },
            step2: {
                time: '',
                content: '',
            },
            step3: {
                time: '',
                content: '',
            },
            step4: {
                time: '',
                content: '',
            },
            step5: {
                time: '',
                content: '',
            },
        }
    },
    props: {
        id: {
            type: String,
        },
    },
    methods: {
        getData() {
            this.showdialog = true;
            var params = {
                id: this.id,
            }
            this.$api.getProjectById(params).then(
                data=>{
                    var dynamic;
                    if (data.dynamic){
                        dynamic = data.dynamic; 
                        this.step1 = dynamic.step1;
                        this.step2 = dynamic.step2;
                        this.step3 = dynamic.step3;
                        this.step4 = dynamic.step4;
                        this.step5 = dynamic.step5;
                        this.step1 = dynamic.step1;
                        this.active_step = dynamic.active_step;
                    } 
                }
            )
        },
        save() {
            var active_step = 0;
            if (this.step1.content){
                if (!this.step1.time){
                    this.$message.error('待入市的时间没有选择');
                    return;
                }
            }
            if (this.step2.content){
                if (!this.step2.time){
                    this.$message.error('即将取证的时间没有选择');
                    return;
                }
                active_step = 1;
            }
            if (this.step3.content){
                if (!this.step3.time){
                    this.$message.error('正在认筹的时间没有选择');
                    return;
                }
                active_step = 2;
            }
            if (this.step4.content){
                if (!this.step4.time){
                    this.$message.error('摇号开盘的时间没有选择');
                    return;
                }
                active_step = 3;
            }
            if (this.step5.content){
                if (!this.step5.time){
                    this.$message.error('持续销售的时间没有选择');
                    return;
                }
                active_step = 4;
            }

            var params = {
                id: this.id,
                active_step,
                step1: JSON.stringify(this.step1),
                step2: JSON.stringify(this.step2),
                step3: JSON.stringify(this.step3),
                step4: JSON.stringify(this.step4),
                step5: JSON.stringify(this.step5),
            };
            this.$api.editProjectDynamic(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.date-input{
    width: 200px;
}
.textarea{
    ::v-deep .el-textarea__inner{
        height: 300px;
    }
}
.sub-div{
    text-align: right;
}
</style>